import { ErrorMessage } from '@/shared/components/ErrorMessage';
import { Table } from './Table';
import { useGetAgreements } from '@/features/agreements/hooks/useAgreements';

export const AgreementsAdmin = () => {
  const agreementsQuery = useGetAgreements();

  if (agreementsQuery.isError) return <ErrorMessage error={agreementsQuery.error} />;

  return (
    <Table records={agreementsQuery.data} loading={agreementsQuery.isFetching} />
  );
};